import { palette } from "../../config";

export default theme => ({
	"@global": {
		// "canvas": {
		// 	width: "70vw",
		// 	height: "auto",
		// 	margin: "auto"
		// },
		"#proxyTrigger": {
			width: "auto",
			height: "100vh",
			backgroundRepeat: "no-repeat",
			backgroundPosition: "center center",
			backgroundSize: "cover",
			backgroundImage: "url(./data/index.jpg)"
		},
		"#target": {
			width: "auto",
			height: "calc(100vh);",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			background: "black",
			"& canvas": {
				alignSelf: "center",
				width: "auto",
				height: "100%"
			}
		}
	},
	root: {
		width: "auto",
		height: "100%",
		alignContent: "center",
		alignItems: "center",
		textAlign: "center",
		display: "flex",
		justifyContent: "center",
		overflow: "hidden",
		"&.rootLCI": {
			height: "calc(100vh)",
			[theme.breakpoints.down("sm")]: {
				height: "auto",
				width: "100vw"
			}
		}
	},
	canvas: {
		width: "auto",
		height: "100vh",
		[theme.breakpoints.down("sm")]: {
			height: "auto",
			width: "100vw"
		}
	},
	arrowsContainer: {
		position: "absolute",
		bottom: "8rem",
		transform: "rotate(0deg)",
		left: "calc(50% - 54px)",
		".rootLCI &": {
			left: "38%"
		}
	},
	arrows: {
		minWidth: "auto",
		marginRight: theme.spacing.unit,
		borderRadius: "0rem",
		border: "1px solid rgba(255, 189, 84, 1)",
		padding: "1px",
		backgroundClip: "content-box",
		backgroundColor: "rgba(255, 189, 84, 1)",
		width: "3.375rem",
		height: "3.375rem"

	},

	arrowLeft: {
		marginRight: theme.spacing.unit * 2
	},
	arrowRight: {
		marginRight: theme.spacing.unit * 2
	},
	arrowIcon: {
		width: "2.5rem",
		height: "2.5rem",
		fill: "rgb(255,255,255)",
		background: theme.palette.primary.background
	},
	eye: {
		position: "absolute"
	},
	[theme.breakpoints.down("sm")]: {
		arrowsContainer: {
			left: "calc(50% - 75px)"
		},
		arrowLeft: {},
		arrowRight: {}
	}



});
